(() => {
  // g5b only (loaded by snippets/cs-header-search.liquid when template.suffix == 'proto-g5b').
  // g5 / g5a keep using assets/cs-header-search.js unchanged.
  // Differences from that file: the dropdown is always fetched through section rendering
  // (the section named by data-cs-suggest-section), /search/suggest is never called (zh-TW answers 417),
  // there are explicit loading / results / empty / error screens, and arrow keys walk one flat list.
  const STRINGS = {
    'zh-TW': { loading: '搜尋中', results: (n) => `${n} 項搜尋結果`, errTitle: '暫時載不到搜尋結果', errBody: '網路好像不太穩，請再試一次。', retry: '再試一次', all: '看全部結果' },
    'zh-CN': { loading: '搜索中', results: (n) => `${n} 项搜索结果`, errTitle: '暂时加载不到搜索结果', errBody: '网络好像不太稳，请再试一次。', retry: '再试一次', all: '查看全部结果' },
    ja: { loading: '検索中', results: (n) => `${n} 件の検索結果`, errTitle: '検索結果を読み込めませんでした', errBody: '通信が不安定なようです。もう一度お試しください。', retry: 'もう一度試す', all: 'すべての結果を見る' },
    en: { loading: 'Searching', results: (n) => `${n} search results`, errTitle: 'Could not load results', errBody: 'The connection looks unstable. Please try again.', retry: 'Try again', all: 'View all results' }
  };
  const lang = (document.documentElement.lang || 'zh-TW').toLowerCase();
  const S = lang.startsWith('ja') ? STRINGS.ja
    : lang.startsWith('zh-cn') || lang.startsWith('zh-hans') ? STRINGS['zh-CN']
    : lang.startsWith('en') ? STRINGS.en : STRINGS['zh-TW'];

  const CSS = `
  .cs-header-search predictive-search[data-cs-suggest-section] .predictive-search { padding: 0; }
  .header .cs-header-search predictive-search[data-cs-suggest-section] .predictive-search { padding: 0; overflow: hidden; }
  .header .cs-header-search predictive-search[data-cs-suggest-section][open] .predictive-search { display: flex; flex-direction: column; }
  .header .cs-header-search predictive-search[data-cs-suggest-section] .cs-header-search__popular { flex: 0 1 auto; min-height: 0; overflow-y: auto; padding: 1rem; }
  .cs-v9 { display: flex; flex-direction: column; flex: 1 1 auto; min-height: 0; min-width: 0; width: 100%; }
  .cs-v9__scroll { flex: 1 1 auto; min-height: 0; position: relative; overflow-x: hidden; overflow-y: auto; overscroll-behavior: contain; scroll-snap-type: y proximity; padding: 0 1.2rem .4rem; scroll-padding-top: 0; scroll-padding-bottom: 0; }
  .cs-v9__group + .cs-v9__group { margin-top: .4rem; }
  .cs-v9__heading { scroll-snap-align: start; display: flex; align-items: baseline; gap: .8rem; margin: 0; padding: 1.2rem 0 .8rem; background: rgb(var(--color-background)); border-bottom: 1px solid rgba(var(--color-foreground), .14); font-size: 1.5rem; line-height: 1.3; letter-spacing: .04em; }
  .cs-v9__count { font-size: 1.2rem; font-weight: 400; color: rgba(var(--color-foreground), .6); }
  .cs-v9__list { display: grid; grid-template-columns: minmax(0, 1fr); gap: .2rem; margin: 0; padding: .6rem 0 0; list-style: none; }
  .cs-v9__list > li { min-width: 0; margin: 0; padding: 0; border-radius: .6rem; scroll-snap-align: start; }
  .cs-v9__list > li[aria-selected='true'] { background: rgba(var(--color-foreground), .07); }
  .cs-v9__list--chips { display: flex; flex-wrap: wrap; gap: .8rem; padding-top: 1rem; padding-bottom: .4rem; }
  .cs-v9__list--chips > li { border-radius: 99rem; }
  .cs-v9__chip { display: inline-flex; align-items: center; min-height: 4.4rem; padding: .4rem 1.4rem; border: 1px solid rgba(var(--color-foreground), .3); border-radius: 99rem; color: rgb(var(--color-foreground)); font-size: 1.4rem; text-decoration: none; }
  .cs-v9__list--chips > li[aria-selected='true'] { background: transparent; }
  .cs-v9__list--chips > li[aria-selected='true'] .cs-v9__chip { border-color: rgb(var(--color-foreground)); background: rgba(var(--color-foreground), .07); }
  .cs-v9__row { display: grid; grid-template-columns: 5.2rem minmax(0, 1fr); align-items: center; gap: 1.2rem; min-width: 0; min-height: 4.8rem; padding: .8rem .4rem; color: rgb(var(--color-foreground)); text-decoration: none; border-radius: .6rem; }
  .cs-v9__row--article { grid-template-columns: 6.4rem minmax(0, 1fr); }
  .cs-v9__thumb { display: block; width: 5.2rem; height: 5.2rem; overflow: hidden; border-radius: .3rem; background: rgba(var(--color-foreground), .06); }
  .cs-v9__thumb--article { width: 6.4rem; height: 6.4rem; }
  .cs-v9__thumb img { display: block; width: 100%; height: 100%; object-fit: cover; }
  .cs-v9__thumb--brand { display: flex; align-items: center; justify-content: center; color: rgb(var(--color-foreground)); }
  .cs-v9__thumb--brand svg { width: 3.4rem; height: 3.4rem; }
  .cs-v9__text { display: flex; flex-direction: column; gap: .3rem; min-width: 0; }
  .cs-v9__title { display: -webkit-box; overflow: hidden; overflow-wrap: anywhere; -webkit-box-orient: vertical; -webkit-line-clamp: 2; font-size: 1.4rem; line-height: 1.35; }
  .cs-v9__price { font-size: 1.4rem; }
  .cs-v9__meta { display: flex; align-items: center; gap: .6rem; min-width: 0; font-size: 1.2rem; color: rgba(var(--color-foreground), .65); }
  .cs-v9__tag { flex: none; padding: 0 .6rem; border: 1px solid rgb(var(--color-foreground)); color: rgb(var(--color-foreground)); font-size: 1.1rem; line-height: 1.7rem; letter-spacing: .06em; }
  .cs-v9__blog { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .cs-v9 a:focus-visible { outline: 2px solid rgb(var(--color-foreground)); outline-offset: 1px; }
  .cs-v9__foot { flex: none; padding: 1rem 1.2rem 1.2rem; background: rgb(var(--color-background)); border-top: 1px solid rgba(var(--color-foreground), .14); }
  .cs-v9__all { display: flex; align-items: center; justify-content: center; min-height: 4.4rem; border-radius: .4rem; background: rgb(var(--color-foreground)); color: rgb(var(--color-background)); font-size: 1.4rem; letter-spacing: .12em; text-decoration: none; }
  .cs-v9__empty { display: flex; flex-direction: column; gap: .6rem; margin: 0; padding: 2.4rem .4rem; text-align: center; }
  .cs-v9__empty span { font-size: 1.3rem; color: rgba(var(--color-foreground), .65); }
  .cs-v9-state { flex: 1 1 auto; min-height: 0; overflow: hidden; padding: 1.2rem; }
  .cs-v9-skel { display: grid; grid-template-columns: 5.2rem minmax(0, 1fr); gap: 1.2rem; align-items: center; padding: .8rem .4rem; }
  .cs-v9-skel > i, .cs-v9-skel b, .cs-v9-skel u { display: block; border-radius: .3rem; background: rgba(var(--color-foreground), .09); animation: cs-v9-pulse 1.2s ease-in-out infinite; }
  .cs-v9-skel > i { width: 5.2rem; height: 5.2rem; }
  .cs-v9-skel b { height: 1.3rem; width: 86%; }
  .cs-v9-skel u { height: 1.1rem; width: 38%; margin-top: .8rem; text-decoration: none; }
  .cs-v9-skel > span { display: block; }
  @keyframes cs-v9-pulse { 0%, 100% { opacity: 1; } 50% { opacity: .45; } }
  @media (prefers-reduced-motion: reduce) { .cs-v9-skel > i, .cs-v9-skel b, .cs-v9-skel u { animation: none; } }
  .cs-v9-error { display: flex; flex-direction: column; align-items: flex-start; gap: .8rem; padding: 2rem 1.6rem; }
  .cs-v9-error strong { font-size: 1.5rem; }
  .cs-v9-error span { font-size: 1.3rem; color: rgba(var(--color-foreground), .7); }
  .cs-v9-error__actions { display: flex; flex-wrap: wrap; gap: 1rem; margin-top: .6rem; }
  .cs-v9-error button, .cs-v9-error a { display: inline-flex; align-items: center; justify-content: center; min-height: 4.4rem; padding: 0 1.8rem; border: 1px solid rgb(var(--color-foreground)); border-radius: .4rem; background: transparent; color: rgb(var(--color-foreground)); font: inherit; font-size: 1.4rem; text-decoration: none; cursor: pointer; }
  .cs-v9-error button { background: rgb(var(--color-foreground)); color: rgb(var(--color-background)); }
  `;
  const styleEl = document.createElement('style');
  styleEl.id = 'cs-v9-search-css';
  styleEl.textContent = CSS;
  document.head.appendChild(styleEl);

  customElements.whenDefined('predictive-search').then(() => {
    const search = document.querySelector('.cs-header-search predictive-search');
    if (!search) return;

    const sectionId = search.dataset.csSuggestSection || 'cs-search-suggest-v9';
    const input = search.querySelector('input[type="search"]');
    const results = search.querySelector('#cs-hs-results');
    const popularTemplate = search.querySelector('#cs-hs-popular-template');
    const originalClear = search.clear.bind(search);
    const TIMEOUT_MS = 8000;
    const cache = new Map();
    let activeController = null;
    let requestId = 0;
    let closed = true;
    let suppressFocus = false;
    const inputRequestIds = new WeakMap();

    const currentQuery = () => input.value.trim();
    const setState = (state) => search.setAttribute('data-cs-state', state);

    const cancelPending = () => {
      requestId += 1;
      activeController?.abort();
      activeController = null;
      search.removeAttribute('loading');
    };

    const isSearchActive = () => activeController !== null || search.hasAttribute('open') ||
      search.hasAttribute('loading') || search.contains(document.activeElement);

    const closeSearch = () => {
      closed = true;
      cancelPending();
      search.close();
      clearActive();
      const status = search.querySelector('.predictive-search-status');
      if (status) {
        status.textContent = '';
        status.setAttribute('aria-hidden', 'true');
      }
      setState('closed');
    };

    const showPopular = () => {
      if (closed || currentQuery() || !search.contains(document.activeElement)) return;
      results.replaceChildren(popularTemplate.content.cloneNode(true));
      clearActive();
      pointControlsAt('cs-hs-results');
      search.removeAttribute('results');
      setState('popular');
      search.open();
    };

    const skeleton = () => {
      const wrap = document.createElement('div');
      wrap.className = 'cs-v9-state';
      wrap.setAttribute('data-cs-state', 'loading');
      wrap.setAttribute('role', 'status');
      wrap.setAttribute('aria-busy', 'true');
      wrap.setAttribute('aria-label', S.loading);
      let rows = '';
      for (let i = 0; i < 4; i += 1) {
        rows += '<div class="cs-v9-skel"><i></i><span><b></b><u></u></span></div>';
      }
      wrap.innerHTML = rows;
      return wrap;
    };

    const errorPanel = (term) => {
      const wrap = document.createElement('div');
      wrap.className = 'cs-v9-state';
      wrap.setAttribute('data-cs-state', 'error');
      const box = document.createElement('div');
      box.className = 'cs-v9-error';
      box.setAttribute('role', 'alert');
      const strong = document.createElement('strong');
      strong.textContent = S.errTitle;
      const span = document.createElement('span');
      span.textContent = S.errBody;
      const actions = document.createElement('div');
      actions.className = 'cs-v9-error__actions';
      const retry = document.createElement('button');
      retry.type = 'button';
      retry.setAttribute('data-cs-retry', '1');
      retry.textContent = S.retry;
      const all = document.createElement('a');
      all.href = `${search.dataset.csSearchUrl}?q=${encodeURIComponent(term)}&type=product%2Carticle`;
      all.textContent = S.all;
      actions.append(retry, all);
      box.append(strong, span, actions);
      wrap.append(box);
      return wrap;
    };

    // Combobox (W3C APG): DOM focus stays on the input; aria-activedescendant names the active option.
    const clearActive = () => {
      results.querySelectorAll('li[aria-selected="true"]').forEach((li) => li.setAttribute('aria-selected', 'false'));
      input.removeAttribute('aria-activedescendant');
    };
    const pointControlsAt = (id) => {
      input.setAttribute('aria-controls', id);
      input.setAttribute('aria-owns', id);
    };

    // The list is not sticky-headed any more; at the largest scroll position the top edge must not cut a row.
    // Extra bottom padding on the scroller lets the largest scroll position land exactly on the top of a row or group heading.
    let fitObserver = null;
    const fitScroll = () => {
      const sc = results.querySelector('.cs-v9__scroll');
      if (!sc) return;
      sc.style.paddingBottom = '';
      const view = sc.clientHeight;
      if (!view) return;
      const base = sc.scrollHeight - view;
      if (base <= 1) return;
      let best = null;
      sc.querySelectorAll('.cs-v9__heading, li[role="option"]').forEach((el) => {
        const top = el.offsetTop; // layout position inside the scroller (not affected by the open animation's transform)
        if (top >= base - 0.01 && (best === null || top < best)) best = top;
      });
      if (best !== null && best > base) sc.style.paddingBottom = `calc(.4rem + ${Math.ceil(best - base)}px)`;
    };
    const watchFit = () => {
      fitObserver?.disconnect();
      const sc = results.querySelector('.cs-v9__scroll');
      if (!sc || !window.ResizeObserver) return;
      fitObserver = new ResizeObserver(() => fitScroll());
      fitObserver.observe(sc);
    };

    const showResultsMarkup = (markup, term) => {
      results.innerHTML = markup;
      const root = results.querySelector('#cs-v9-root');
      clearActive();
      pointControlsAt(results.querySelector('#cs-v9-listbox') ? 'cs-v9-listbox' : 'cs-hs-results');
      search.setAttribute('results', 'true');
      search.removeAttribute('loading');
      const shown = results.querySelectorAll('li[role="option"]').length;
      setState(shown ? 'results' : 'empty');
      search.open();
      fitScroll();
      requestAnimationFrame(fitScroll);
      setTimeout(fitScroll, 400);
      watchFit();
      const statusText = shown ? S.results(shown) : (root.querySelector('.cs-v9__empty')?.textContent.trim() || '');
      search.setLiveRegionText(statusText);
    };

    const showError = (term) => {
      results.replaceChildren(errorPanel(term));
      clearActive();
      pointControlsAt('cs-hs-results');
      search.removeAttribute('results');
      search.removeAttribute('loading');
      setState('error');
      search.open();
      search.setLiveRegionText(`${S.errTitle}。${S.errBody}`);
    };

    const sectionResults = async (term, id) => {
      const key = term.toLowerCase();
      if (cache.has(key)) {
        showResultsMarkup(cache.get(key), term);
        return;
      }
      results.replaceChildren(skeleton());
      clearActive();
      pointControlsAt('cs-hs-results');
      search.removeAttribute('results');
      setState('loading');
      search.open();

      const controller = new AbortController();
      activeController = controller;
      let timedOut = false;
      const timer = setTimeout(() => { timedOut = true; controller.abort(); }, TIMEOUT_MS);

      const url = new URL(search.dataset.csSearchUrl, window.location.origin);
      url.searchParams.set('q', term);
      url.searchParams.set('type', 'product,article');
      url.searchParams.set('section_id', sectionId);

      try {
        const response = await fetch(url.toString(), { signal: controller.signal });
        if (!response.ok) throw new Error(`Search section returned ${response.status}`);
        const html = await response.text();
        const section = new DOMParser().parseFromString(html, 'text/html')
          .querySelector(`#shopify-section-${sectionId}`);
        if (!section?.querySelector('#cs-v9-root')) throw new Error('Search section markup was missing');
        if (id !== requestId || closed || !search.contains(document.activeElement) || currentQuery() !== term) return;
        cache.set(key, section.innerHTML);
        showResultsMarkup(section.innerHTML, term);
      } catch (error) {
        const stale = id !== requestId || closed || !search.contains(document.activeElement);
        if (error.name === 'AbortError' && !timedOut) return;
        if (!stale) showError(term);
      } finally {
        clearTimeout(timer);
        if (activeController === controller) activeController = null;
        if (id === requestId) search.removeAttribute('loading');
      }
    };

    // Same hook point as cs-header-search.js: replace the theme's fetch, keep its 300 ms debounce.
    search.getSearchResults = async (term) => {
      if (!term || closed || !search.contains(document.activeElement)) return;
      cancelPending();
      const id = requestId;
      search.setLiveRegionLoadingState();
      await sectionResults(term, id);
    };

    search.clear = (event) => {
      cancelPending();
      originalClear(event || { preventDefault() {} });
      queueMicrotask(showPopular);
    };

    const originalOnChange = search.onChange.bind(search);
    search.onChange = (event) => {
      if (closed || !search.contains(document.activeElement) ||
        (event && inputRequestIds.get(event) !== requestId)) return;
      if (!currentQuery()) {
        showPopular();
        return;
      }
      originalOnChange(event);
    };

    input.addEventListener('focus', (event) => {
      // Esc puts focus back on the input; the theme's own focus handler would reopen the panel.
      if (suppressFocus) {
        event.stopImmediatePropagation();
        return;
      }
      closed = false;
      showPopular();
    }, true);

    input.addEventListener('input', (event) => {
      cancelPending();
      input.removeAttribute('aria-activedescendant');
      inputRequestIds.set(event, requestId);
      closed = false;
      search.removeAttribute('results');
      search.close();
      showPopular();
    });

    search.addEventListener('keyup', (event) => {
      // Escape has already dismissed the popup. Skip the theme's empty-query
      // clear/focus handler and the popular-search queue for this keystroke.
      if (event.key === 'Escape') {
        event.stopImmediatePropagation();
        return;
      }
      if (event.target.closest('.cs-header-search__popular-pill')) {
        event.stopImmediatePropagation();
      }
    }, true);

    search.addEventListener('keyup', () => {
      if (!currentQuery()) queueMicrotask(showPopular);
    });

    results.addEventListener('click', (event) => {
      const retry = event.target.closest('[data-cs-retry]');
      if (retry && results.contains(retry)) {
        cancelPending();
        closed = false;
        const id = requestId;
        search.setLiveRegionLoadingState();
        sectionResults(currentQuery(), id);
        return;
      }
      const pill = event.target.closest('[data-cs-popular-term]');
      if (!pill || !results.contains(pill)) return;
      input.value = pill.dataset.csPopularTerm;
      input.focus();
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });

    // The theme's switchOption stops at the end of one <ul> and moves DOM focus onto the link.
    // Here focus stays on the input; every option in the panel is one list, aria-activedescendant follows the selection.
    search.switchOption = (direction) => {
      if (!search.hasAttribute('open')) return;
      const options = Array.from(results.querySelectorAll('li[role="option"]'));
      if (!options.length) return;
      const current = options.findIndex((li) => li.getAttribute('aria-selected') === 'true');
      let next;
      if (direction === 'up') {
        if (current === -1) return;
        next = (current - 1 + options.length) % options.length;
      } else {
        next = current === -1 ? 0 : (current + 1) % options.length;
      }
      if (document.activeElement !== input) input.focus({ preventScroll: true });
      options.forEach((li) => li.setAttribute('aria-selected', li === options[next] ? 'true' : 'false'));
      const chosen = options[next];
      input.setAttribute('aria-activedescendant', chosen.id);
      chosen.scrollIntoView({ block: 'nearest' });
      search.setLiveRegionText(chosen.textContent.replace(/\s+/g, ' ').trim());
    };

    // The theme's Tab handler loops focus through the options and never lets it reach the "view all" link.
    // Options are not tab stops (activedescendant model), so Tab just walks input, buttons, "view all", then leaves.
    search.addEventListener('keydown', (event) => {
      if (event.key === 'Tab') event.stopPropagation();
    }, true);
    // A11Y-01 #3 (m42d/m42e, 10-12): Tab's keyup lands on the newly focused button inside <predictive-search>; the theme's
    // onKeyup sees an empty query, calls clear(), and clear() runs input.focus() — focus snaps back ~one keystroke later.
    // Stop Tab's keyup here too so Tab / Shift+Tab can leave the input.
    search.addEventListener('keyup', (event) => {
      if (event.key === 'Tab') event.stopPropagation();
    }, true);

    search.querySelector('button[type="button"]').addEventListener('click', closeSearch);
    search.querySelector('button[type="reset"]').addEventListener('click', cancelPending);

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !isSearchActive()) return;
      // Native search-input Escape clearing can emit input and reopen popular
      // searches. Dismiss without changing the query, only within this search.
      if (search.contains(event.target)) event.preventDefault();
      const focusInResults = results.contains(document.activeElement);
      closeSearch();
      if (focusInResults) {
        suppressFocus = true;
        input.focus();
        suppressFocus = false;
      }
    });

    document.addEventListener('pointerdown', (event) => {
      if (!search.contains(event.target) && isSearchActive()) closeSearch();
    });

    search.addEventListener('focusout', () => {
      setTimeout(() => {
        if (!search.contains(document.activeElement)) closeSearch();
      });
    });

    // Reconcile input used before the deferred custom-element handlers were ready.
    search.setAttribute('data-cs-search-ready', 'true');
    if (document.activeElement === input) {
      closed = false;
      const query = currentQuery();
      if (query) search.getSearchResults(query);
      else showPopular();
    }
  });
})();
